import axios from "axios";
import { BASE_URL } from '../Utils/base_url';

const AfficheRestaurantHome = async (page) => {
    return await axios.get(`${BASE_URL}/listeRestaurant/${page}`);
}

export { AfficheRestaurantHome }